import GoogleSheets from "../../../../contents/docs/cdp/sources/_snippets/source-google-sheets.mdx";
import * as React from 'react';
export default {
  GoogleSheets,
  React
};